import { darkStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import "./jsonViewerStyles.css";

export const jsonViewerStyles = {
  ...darkStyles,
  stringValue: `${darkStyles.stringValue} jv-custom-string`,
  label: `${darkStyles.label} jv-custom-label`,
  clickableLabel: `${darkStyles.clickableLabel} jv-custom-label`,
  booleanValue: `${darkStyles.booleanValue} jv-custom-boolean`,
};
